var _path, _path2, _path3, _rect, _circle, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBioData(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 71,
    viewBox: "0 0 69 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.2703 4.31781C38.8893 4.56195 38.8893 5.43805 38.2703 5.68219L36.7105 6.29736C36.5215 6.3719 36.3719 6.5215 36.2974 6.7105L35.6822 8.27027C35.438 8.88931 34.562 8.88931 34.3178 8.27027L33.7026 6.7105C33.6281 6.5215 33.4785 6.3719 33.2895 6.29736L31.7297 5.68219C31.1107 5.43805 31.1107 4.56195 31.7297 4.31781L33.2895 3.70264C33.4785 3.6281 33.6281 3.4785 33.7026 3.2895L34.3178 1.72973C34.562 1.11068 35.438 1.11069 35.6822 1.72973L36.2974 3.2895C36.3719 3.4785 36.5215 3.6281 36.7105 3.70264L38.2703 4.31781Z",
    fill: "#7A828A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.27027 43.3178C9.88931 43.562 9.88931 44.438 9.27027 44.6822L7.7105 45.2974C7.5215 45.3719 7.3719 45.5215 7.29736 45.7105L6.68219 47.2703C6.43805 47.8893 5.56195 47.8893 5.31781 47.2703L4.70264 45.7105C4.6281 45.5215 4.4785 45.3719 4.2895 45.2974L2.72973 44.6822C2.11069 44.438 2.11069 43.562 2.72973 43.3178L4.2895 42.7026C4.4785 42.6281 4.6281 42.4785 4.70264 42.2895L5.31781 40.7297C5.56195 40.1107 6.43805 40.1107 6.68219 40.7297L7.29736 42.2895C7.3719 42.4785 7.5215 42.6281 7.7105 42.7026L9.27027 43.3178Z",
    fill: "#7A828A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.2703 62.3178C67.8893 62.562 67.8893 63.438 67.2703 63.6822L65.7105 64.2974C65.5215 64.3719 65.3719 64.5215 65.2974 64.7105L64.6822 66.2703C64.438 66.8893 63.562 66.8893 63.3178 66.2703L62.7026 64.7105C62.6281 64.5215 62.4785 64.3719 62.2895 64.2974L60.7297 63.6822C60.1107 63.438 60.1107 62.562 60.7297 62.3178L62.2895 61.7026C62.4785 61.6281 62.6281 61.4785 62.7026 61.2895L63.3178 59.7297C63.562 59.1107 64.438 59.1107 64.6822 59.7297L65.2974 61.2895C65.3719 61.4785 65.5215 61.6281 65.7105 61.7026L67.2703 62.3178Z",
    fill: "#7A828A"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 28,
    height: 28,
    rx: 10,
    fill: "#E0C589"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46.5,
    cy: 31.5,
    r: 2.5,
    fill: "#E0C589"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 36.5H51.4368M23.5 42.5H46.8983M23 49H41.4234M22.3851 55.3194H36.1702",
    stroke: "#7A828A"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 21L56.5 20.5L51 63L13.5 61.5L18 36",
    stroke: "#E0C589",
    strokeWidth: 1.16
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5215 35.6088C20.3548 35.9421 27 34.6 29 25",
    stroke: "#7A828A",
    strokeWidth: 1.16
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7126 27.9763L12.2615 28.4461L12.7515 27.9151L22.4382 17.4182C23.0396 16.7666 22.9988 15.7509 22.3472 15.1496C21.6956 14.5482 20.6798 14.589 20.0785 15.2406L11.9996 23.9953L8.61471 21.098C7.9411 20.5214 6.92761 20.6001 6.35103 21.2737C5.77445 21.9473 5.85311 22.9608 6.52672 23.5374L11.7126 27.9763Z",
    fill: "white",
    stroke: "#7A828A",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1942 13.6681L63.25 12.5L55.25 70L6.75 66.5L13.25 35",
    stroke: "#7A828A",
    strokeWidth: 1.4
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBioData);
export default __webpack_public_path__ + "static/media/bio-data.7dfb0681ed0333eac5fdc688c143feae.svg";
export { ForwardRef as ReactComponent };